import { render, staticRenderFns } from "./GroupBookingDocumentActions.vue?vue&type=template&id=21d38ce6&"
import script from "./GroupBookingDocumentActions.vue?vue&type=script&lang=js&"
export * from "./GroupBookingDocumentActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports